import { Box, Checkbox, Text } from "@chakra-ui/react";
import { surfaceShadow } from "../constants";

export function ChecklistCard({
  checked,
  onCheckedChange,
  title,
  children,
  error,
}: {
  checked: boolean;
  onCheckedChange: (value: boolean) => void;
  title: string;
  children: React.ReactNode;
  error?: string;
}) {
  return (
    <Box spaceY={2} data-onboarding-error={error ? "true" : undefined}>
      <Box
        as="label"
        display="flex"
        gap={4}
        p={5}
        w="full"
        borderWidth={error ? "1px" : "0"}
        borderColor={error ? "red.300" : "transparent"}
        borderRadius="xl"
        bg="white"
        boxShadow={error ? "none" : surfaceShadow}
        cursor="pointer"
        _hover={{ bg: "gray.50" }}
        transition="colors 0.2s"
      >
        <Checkbox.Root
          checked={checked}
          onCheckedChange={(e) => onCheckedChange(e.checked === true)}
          mt={1}
        >
          <Checkbox.HiddenInput />
          <Checkbox.Control>
            <Checkbox.Indicator />
          </Checkbox.Control>
        </Checkbox.Root>
        <Box fontSize="sm" color="gray.600" lineHeight="tall">
          <Text fontWeight="bold" color="gray.900" display="block" mb={1}>{title}</Text>
          {children}
        </Box>
      </Box>
      {error && <Text fontSize="xs" color="red.500">{error}</Text>}
    </Box>
  );
}
